<template>
  <v-row>
    <v-col>
      <h1>Доставка</h1>
      <v-tabs v-model="tab">
        <v-tab>Районы</v-tab>
        <v-tab>Улицы</v-tab>
        <v-tab>Филиалы</v-tab>
        <v-tab>Цеха</v-tab>
        <v-tab>Цеха (занятые)</v-tab>
        <v-tab>Настройки</v-tab>
        <v-tab>Типы заказов</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item><areas></areas></v-tab-item>
        <v-tab-item><streets></streets></v-tab-item>
        <v-tab-item><branches></branches></v-tab-item>
        <v-tab-item><workshops></workshops></v-tab-item>
        <v-tab-item><workshops-busy></workshops-busy></v-tab-item>
        <v-tab-item>
          <v-checkbox v-model="isPayDeliveryEnabled.value" label="Платная доставка включена"
                      @click="updateIsPayDeliveryEnabled"></v-checkbox>
          <v-row>
            <v-col cols="6" sm="4" lg="3">
              <v-text-field   label="Минимальная версия iOS приложения"
                              outlined
                              v-model="minIOSVersion.value"
                              @blur="updateMinIOSVersion()"/>
              <v-text-field   label="Минимальная версия Android приложения"
                              outlined
                              v-model="minAndroidVersion.value"
                              @blur="updateAndroidVersion()"/>
              <v-text-field   label="Количество бонусов при первом открытии приложения"
                              outlined
                              v-model="giftBonusAmount.value"
                              @blur="updateGiftBonusAmount()"/>
              <v-select
                  label="Сервис онлайн оплаты оплаты"
                  :items="payServices"
                  v-model="payService.value"
                  outlined
                @change="updatePayService">
              </v-select>
            </v-col>
          </v-row>

          <v-btn class="mt-16" :loading="loadingGlovoMenu" @click="exportGlovoMenu">Выгрузить в Глово меню</v-btn>
          <v-btn class="mt-16 ml-8" :loading="loadingEshoGlovoMenu" @click="exportEshoGlovoMenu">Выгрузить в Глово меню ЕШО</v-btn>


          <br/>
          <br/>
          <br/>

          <h1>Высокие этажи</h1>
          <v-checkbox v-model="floorEnabled" label="Включён"
                      @click="updateFloorSettings"></v-checkbox>
          <v-text-field  label="Работает с этажа №"
                         v-model="floorMinStep"
                         outlined
                         @blur="updateFloorSettings"></v-text-field>
          <v-text-field  label="Текст на русском"
                         v-model="floorErrorRu"
                         outlined
                         @blur="updateFloorSettings"></v-text-field>
          <v-text-field  label="Текст на украинском"
                         v-model="floorErrorUa"
                         outlined
                         @blur="updateFloorSettings"></v-text-field>
          <v-text-field  label="Соглащаюсь на русском"
                         v-model="floorOkRu"
                         outlined
                         @blur="updateFloorSettings"></v-text-field>
          <v-text-field  label="Соглащаюсь на украинском"
                         v-model="floorOkUa"
                         outlined
                         @blur="updateFloorSettings"></v-text-field>
          <v-text-field  label="Отказываюсь на русском"
                         v-model="floorCancelRu"
                         outlined
                         @blur="updateFloorSettings"></v-text-field>
          <v-text-field  label="Отказываюсь на украинском"
                         v-model="floorCancelUa"
                         outlined
                         @blur="updateFloorSettings"></v-text-field>
        </v-tab-item>
        <v-tab-item><order-type></order-type></v-tab-item>
      </v-tabs-items>
    </v-col>
  </v-row>
</template>

<script>
  // @ is an alias to /src
  import Areas from './Area/Index'
  import Streets from './Street/Index'
  import Workshops from './Workshop/Index'
  import WorkshopsBusy from './Workshop/Busy.vue'
  import Branches from './Branch/Index'
  import OrderType from './OrderType/Index'
  import SettingService from './../../api/SettingService'

  export default {
    name: 'DeliveryIndex',
    data: () => ({
      isPayDeliveryEnabled: {},
      minIOSVersion: {},
      minAndroidVersion: {},
      giftBonusAmount: {},
      loadingGlovoMenu: false,
      loadingEshoGlovoMenu: false,
      floorId: null,
      floorEnabled: false,
      floorMinStep: 6,
      floorErrorRu: '',
      floorErrorUa: '',
      floorOkRu: '',
      floorOkUa: '',
      floorCancelRu: '',
      floorCancelUa: '',
      payServices: [
        'liqpay', 'wayforpay'
      ],
      payService: {}
    }),
    props: {
        tab: {
          default: 0,
          type: Number
        }
    },
    components: {Areas, Streets, Branches, Workshops, OrderType, WorkshopsBusy},
    mounted() {
      SettingService.get('min_ios_version').then(response => {
        this.minIOSVersion = response.data
      });

      SettingService.get('min_android_version').then(response => {
        this.minAndroidVersion = response.data
      });

      SettingService.get('gift_bonus_amount').then(response => {
        this.giftBonusAmount = response.data
      });

      SettingService.get('pay_service').then(response => {
        this.payService = response.data
      });

      SettingService.get('floor_settings').then(response => {

         const {minStep = 6, enabled = false,
           translate_text_ru = 'Мы не сможем подняться, если не будет работать лифт',
           translate_text_ua = 'Ми не зможемо піднятись, якщо не працюватиме ліфт',
           translate_ok_ru = 'Хорошо',
           translate_ok_ua = 'Погоджуюсь',
           translate_cancel_ru = 'Отказаться',
           translate_cancel_ua = 'Скасувати',
         } = JSON.parse(response.data.value);


         this.floorId = response.data.id;
         this.floorEnabled = enabled;
         this.floorMinStep = minStep;
         this.floorErrorRu = translate_text_ru;
         this.floorErrorUa = translate_text_ua;
         this.floorOkRu = translate_ok_ru;
         this.floorOkUa = translate_ok_ua;
         this.floorCancelRu = translate_cancel_ru;
         this.floorCancelUa = translate_cancel_ua;
      });

      SettingService.get('is_pay_delivery_enabled').then(response => {
        this.isPayDeliveryEnabled = response.data
        if (this.isPayDeliveryEnabled.value == "true") {
          this.isPayDeliveryEnabled.value = true
        } else {
          this.isPayDeliveryEnabled.value = false
        }
      });

    },
    watch: {},
    methods: {
      async exportGlovoMenu(){
        this.loadingGlovoMenu = true
        await SettingService.exportGlovoMenu()
        this.loadingGlovoMenu = false
      },
      async exportEshoGlovoMenu(){
        this.loadingEshoGlovoMenu = true
        await SettingService.exportEshoGlovoMenu()
        this.loadingEshoGlovoMenu = false
      },
      updateMinIOSVersion() {
        SettingService.update(this.minIOSVersion.id, {value: this.minIOSVersion.value})
      },
      updateAndroidVersion() {
        SettingService.update(this.minAndroidVersion.id, {value: this.minAndroidVersion.value})
      },
      updateGiftBonusAmount() {
        SettingService.update(this.giftBonusAmount.id, {value: this.giftBonusAmount.value})
      },
      updateIsPayDeliveryEnabled() {
        SettingService.update(this.isPayDeliveryEnabled.id, {value: this.isPayDeliveryEnabled.value})
      },
      updatePayService() {
        SettingService.update(this.payService.id, {value: this.payService.value})
      },
      updateFloorSettings() {
        SettingService.update(this.floorId, {value: JSON.stringify({
            enabled: this.floorEnabled,
            minStep: this.floorMinStep,
            translate_text_ru: this.floorErrorRu,
            translate_text_ua: this.floorErrorUa,
            translate_ok_ru: this.floorOkRu,
            translate_ok_ua: this.floorOkUa,
            translate_cancel_ru: this.floorCancelRu,
            translate_cancel_ua: this.floorCancelUa,
          })});
      },
    }
  }
</script>

<style scoped lang="scss">
::v-deep{
  .v-select__selections{
    position: relative;
    top: 6px;
  }
}
</style>
